import React, { ReactNode } from "react";
import styled from "styled-components";
import { getHorizontalGap } from "../../styles";
import Typography from "../Typography/Typography";

const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${getHorizontalGap("32px")};
  overflow-x: auto;
  padding-bottom: 12px;
  margin-bottom: 30px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileL}) {
    ${getHorizontalGap("16px")};
  }
`;

const HeaderItem = styled.button<{ isActive: boolean }>`
  padding: 10px 20px;
  background-color: ${({ theme, isActive }) =>
    isActive ? theme.lightBackgroundColor : "transparent"};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  transition: background-color 200ms ease-in;

  &:hover {
    background-color: ${({ theme }) => theme.lightBackgroundColor};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 10px;
  }
`;

const HeaderText = styled(Typography)`
  @media (max-width: ${({ theme }) => theme.breakpoints.mobileL}) {
    font-size: ${({ theme }) => theme.paragraph.md};
  }
`;

type SectionId = number | string;

interface ISection {
  id: SectionId;
  title: ReactNode;
  content: ReactNode;
}

interface IProps {
  sections: ISection[];
  activeSectionId?: string | number;
  setActiveSectionId: (id: string | number) => void;
}

const Sections = ({
  sections,
  activeSectionId = sections[0].id,
  setActiveSectionId,
}: IProps) => {
  const activeSection = sections.find(({ id }) => id === activeSectionId);

  return (
    <>
      <Header>
        {sections.map(({ id, title }) => {
          const isActive = id === activeSectionId;

          return (
            <HeaderItem
              key={id}
              isActive={isActive}
              onClick={() => setActiveSectionId(id)}
            >
              <HeaderText weight="400" size="lg" secondary={!isActive}>
                {title}
              </HeaderText>
            </HeaderItem>
          );
        })}
      </Header>
      {activeSection?.content}
    </>
  );
};

export default Sections;
